export default __webpack_public_path__ + "static/media/mongoDB.153b7b44.svg";